import Form from "components/common/form/Form";
import Input from "components/common/form/inputs/Input";
import FormActions from "components/common/form/partials/FormActions";
import {useState} from "react";
import useAppContext from "utilities/hooks/useAppContext";
import BookingTotalCharge from "../views/BookingTotalCharge";
import {faCalculator, faCheck} from "@fortawesome/free-solid-svg-icons";

type BookingPaidAmountFormPropsType = {
    bookingId: number,
    paidAmount: number,
    additionalAmount: number,
    totalAmount: number,
    onSubmit: (bookingId: number, amount: number) => Promise<void>
}

const BookingPaidAmountForm = (props: BookingPaidAmountFormPropsType) => {
    const context = useAppContext();
    const [model, setModel] = useState<string>(props.paidAmount === 0 ? '' : props.paidAmount.toString());

    return (
        <div>
            <BookingTotalCharge
                total={props.totalAmount}
                additionalCharge={props.additionalAmount}
                paid={props.paidAmount}
            />
            <Form
                name="paidAmount"
                onSubmit={() => props.onSubmit(Number(model), props.bookingId)}
                onReset={() => context.navigate(-1)}
            >
                <Input
                    type="number"
                    label="fields.amount.name"
                    name="amount"
                    value={model}
                    autoFocus
                    onChange={e => setModel(e || '')}
                    suffix={[
                        {
                            icon: faCheck,
                            name: 'total',
                            title: 'fields.total.name',
                            onClick: () => setModel((props.totalAmount + props.additionalAmount)?.toString())
                        },
                        {
                            icon: faCalculator,
                            name: 'calculate',
                            title: "form.booking.calculated-price",
                            onClick: () => setModel(Number(model).toString())
                        }
                    ]}
                />
                <FormActions/>
            </Form>
        </div>
    );
};

export default BookingPaidAmountForm;
